export enum VIEW {
    DEFAULT = 'default',
    WITH_LESSON = 'with-lesson',
}
